import { useState } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { getAvatarByName } from "@/data/dummy";

const pastelColors = [
  "bg-orange-200 text-orange-800",
  "bg-sky-200 text-sky-800",
  "bg-emerald-200 text-emerald-800",
  "bg-violet-200 text-violet-800",
  "bg-rose-200 text-rose-800",
  "bg-amber-200 text-amber-800",
];

function getColor(name: string) {
  if (!name) return pastelColors[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return pastelColors[Math.abs(hash) % pastelColors.length];
}

function getInitials(name?: string | null) {
  const safe = typeof name === "string" ? name.trim() : "";
  if (!safe) return "?";
  const initials = safe
    .split(" ")
    .map((n) => n[0])
    .filter(Boolean)
    .join("")
    .toUpperCase()
    .slice(0, 2);
  return initials || "?";
}

export default function UserAvatar({ name, src, size = "sm", fixedColor }: { name?: string | null; src?: string; size?: "xs" | "sm" | "md" | "lg"; fixedColor?: string }) {
  const [imageError, setImageError] = useState(false);
  const { t } = useTranslation();
  const sizeMap = { xs: "h-6 w-6 text-[10px]", sm: "h-8 w-8 text-xs", md: "h-10 w-10 text-sm", lg: "h-12 w-12 text-base" };
  const safeName = typeof name === "string" ? name.trim() : "";
  const resolvedSrc = src || (safeName ? getAvatarByName(safeName) : undefined);

  if (resolvedSrc && !imageError) {
    return (
      <img
        src={resolvedSrc}
        alt={safeName || t("grid.cell.userAvatar")}
        className={cn("rounded-full object-cover", sizeMap[size])}
        onError={() => setImageError(true)}
      />
    );
  }
  return (
    <div className={cn("rounded-full flex items-center justify-center font-medium shrink-0", sizeMap[size], fixedColor || getColor(safeName))}>
      {getInitials(safeName)}
    </div>
  );
}
